<!-- 查询通用券账单信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNo": "粤A12345",
                "obtainStartTime": "2019-04-28 00:00:00",
                "obtainEndTime": "2020-04-28 00:00:00",
                "pageNum": 1,
                "pageSize": 10
            },
            responseCode: {
                "data": {
                    "userCouponBillList": [
                        {
                            "carNo": "粤A12345",
                            "couponName": "城市运营测试抵扣1元券",
                            "couponSn": "20190429142121000001",
                            "couponTemplateCode": "8S30EDCU15XF",
                            "couponType": 1,
                            "faceValue": "1",
                            "grantUser": "测试授权商",
                            "obtainTime": "2019-04-29 14:21:21",
                            "status": 0,
                            "validFrom": "2019-04-29 14:21:21",
                            "validTo": "2019-05-06 14:21:21"
                        },
                        {
                            "carNo": "粤A12345",
                            "couponName": "城市运营测试抵扣1元券",
                            "couponSn": "20190429115828000001",
                            "couponTemplateCode": "8S303FTHIFXM",
                            "couponType": 1,
                            "faceValue": "1",
                            "grantUser": "测试授权商",
                            "obtainTime": "2019-04-29 11:58:28",
                            "status": 0,
                            "validFrom": "2019-04-29 11:58:28",
                            "validTo": "2019-05-06 11:58:28"
                        }
                    ]
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询发券记录, 券使用记录, 或者指定手机号/车辆号的券记录信息",
                t_url: this.commonUrls.test+"getCityOperationCouponBill",
                p_url: this.commonUrls.prod+"getCityOperationCouponBill",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'mobile', info2: '否', info3: 'String', info4: '用户手机号码' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号' },
                        { info1: 'coopKey', info2: '否', info3: 'String', info4: '授权商key。不填就默认本授权商发的券，填就是可查询其他授权商的券' },
                        { info1: 'useStatus', info2: '否', info3: 'Integer', info4: '使用状态。不填就默认全部，0:NOT_USE(未使用),1:USED(已使用),3:RECOVERED(已回收)' },
                        { info1: 'obtainStartTime', info2: '是', info3: 'String', info4: 'yyyy-MM-dd HH:mm:ss 发券时间段起始时间' },
                        { info1: 'obtainEndTime', info2: '是', info3: 'String', info4: 'yyyy-MM-dd HH:mm:ss 发券时间段结束时间' },
                        { info1: 'useStartTime', info2: '否', info3: 'String', info4: 'yyyy-MM-dd HH:mm:ss 使用券时间段起始时间' },
                        { info1: 'useEndTime', info2: '否', info3: 'String', info4: 'yyyy-MM-dd HH:mm:ss 使用券时间段结束时间' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userCouponBillList', info2: '是', info3: 'JSONArray', info4: '通用券账单信息列表' }
                        ]
                },{
                    titleName: 'userCouponBillList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponTemplateCode', info2: '是', info3: 'String', info4: '券模板编码' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '券名称' },
                        { info1: 'couponSn', info2: '是', info3: 'String', info4: '券编码' },
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '券类型' },
                        { info1: 'faceValue', info2: '是', info3: 'String', info4: '券面值' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '券状态，0:NOT_USE(未使用),1:USED(已使用),3:RECOVERED(已回收)' },
                        { info1: 'validFrom', info2: '是', info3: 'Long', info4: '有效期开始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validTo', info2: '是', info3: 'Long', info4: '有效期结束时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'obtainTime', info2: '是', info3: 'Long', info4: '发券时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'useTime', info2: '是', info3: 'Long', info4: '使用券时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'grantUser', info2: '是', info3: 'String', info4: '发券人/发券授权商' },
                        { info1: 'mobile', info2: '否', info3: 'String', info4: '接收券的手机号(发券接口填写的手机号)' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '接收券的车牌号(发券接口填写的车牌号)' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/cityOperationCoupon/getCityOperationCouponBill.vue